module.exports = __webpack_public_path__ + "static/media/ellipse3.bbf64a8f.png";